import { tokenExpiresAtom, userAtom } from '@/global-store';
import type { UserData } from '@eye-able/types';
import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

export type LoginSessionUser = UserData & { tokenExpires: number };

/**
 * Stores the session from a successful login response. Shared by every login
 * variant, which all answer with the user and, in local development, the
 * session token as a header.
 */
export function useStoreLoginSession() {
  const setUser = useSetAtom(userAtom);
  const setTokenExpires = useSetAtom(tokenExpiresAtom);

  return useCallback(
    async (response: Response): Promise<LoginSessionUser> => {
      const devToken = response.headers.get('X-Dev-Token');
      if (!import.meta.env.PROD && devToken) {
        localStorage.setItem('X-Dev-Token', devToken);
      }

      const user = (await response.json()) as LoginSessionUser;
      user.fullName = `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim();
      setUser(user);
      setTokenExpires(user.tokenExpires);

      return user;
    },
    [setUser, setTokenExpires],
  );
}
